import { Component, Inject, Injector, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalWrapperData } from '../../models/modal-wrapper-data.model';

@Component({
  selector: 'app-modal-wrapper',
  templateUrl: './modal-wrapper.component.html',
  styleUrls: ['./modal-wrapper.component.scss']
})
export class ModalWrapperComponent implements OnInit {

  toInject: Injector;

  constructor(
    public dialogRef: MatDialogRef<ModalWrapperComponent>,
    private injector: Injector,
    @Inject(MAT_DIALOG_DATA) public data: ModalWrapperData,
  ) { }

  ngOnInit(): void {
    this.toInject = Injector.create({
      providers: [
        {
          provide: this.dialogRef,
          useExisting: this.dialogRef,
        },
        {
          provide: MAT_DIALOG_DATA,
          useValue: {
            ...this.data.data
          }
        },
      ],
      parent: this.injector
    });
  }

  get disableCloseBtn() {
    return this.data?.config?.wrapperConfig?.disableCloseBtn ?? false;
  }

}
